export const ROW_GUTTER = { xs: 8, sm: 16, md: 24 };

export const PICTURE_LAYOUT = {
  xs: { span: 20 },
  sm: { span: 20 },
  md: { span: 20 },
  lg: { span: 10 },
  xl: { span: 10 },
  xxl: { span: 10 },
};

export const DETAILS_LAYOUT = {
  xs: { span: 20 },
  sm: { span: 20 },
  md: { span: 20 },
  lg: { span: 12 },
  xl: { span: 12 },
  xxl: { span: 12 },
};

export const PLACEHOLDER_PATH = 'https://goo.gl/fr3HCz';



// WEBPACK FOOTER //
// ./src/components/employeeCard/EmployeeCardConstants.js